import { useOkapiKy } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { fetchAuthorityTypes } from "../api/authorityTypeService";
export var AUTHORITY_TYPES_QUERY_KEY = "czna-authority-types";
/**
 * The authority types a per-type role can be granted for, in display order — record types in
 * the order the rest of the app uses, then vocabulary types (CZNA-650).
 *
 * `authorityTypes` is `undefined` until the list has loaded and stays `undefined` when it
 * failed; callers must consult `isError` rather than read an empty list as "no types".
 */
var useAuthorityTypes = function () {
    var ky = useOkapiKy();
    var _a = useQuery([AUTHORITY_TYPES_QUERY_KEY], function () { return fetchAuthorityTypes(ky); }, 
    // The server caches the registry for 60 s; refetching more often buys nothing.
    { staleTime: 60000 }), data = _a.data, isLoading = _a.isLoading, isError = _a.isError;
    return {
        authorityTypes: data === null || data === void 0 ? void 0 : data.authorityTypes,
        isLoading: isLoading,
        isError: isError,
    };
};
export default useAuthorityTypes;
